<template>
  <div class="special">
    <div class="main">
      <div class="tab">
        <div class="tab_item"
             v-bind:class="tab1=='block'?'active':''"
             @click="tab_change">国土</div>
        <div class="tab_item"
             v-bind:class="tab2=='block'?'active':''"
             @click="tab_change">环保</div>
      </div>
      <div v-show="tab1=='block'" v-html="content1">
      </div>

      <div v-show="tab2=='block'" v-html="content2">
      </div>
    </div>

  </div>
</template>

<script>
import {getSpecialProduct} from '@/api/scheme'
export default {
  name: "special",
  data () {
    return {
      tab1: 'block',
      tab2: 'none',
      content1:'',
      content2:'',
    };
  },
  mounted(){
    getSpecialProduct().then(res=>{
      this.content1=res.data.data[0].content
      this.content2=res.data.data[1].content
    })
  },
  methods: {
    tab_change () {
      var that = this;
      if (that.tab1 == 'block' || that.tab2 == 'none') {
        that.tab1 = 'none';
        that.tab2 = 'block';
      } else {
        that.tab2 = 'none';
        that.tab1 = 'block';
      }
    },
  }
}

</script>

<style scoped>
.special {
  width: 100%;
  margin: 0px auto;
  font-size: 16px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: #212121;
  background: #ffffff;
}

.special .main {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
}

.tab {
  width: 100%;
  border-bottom: 1px solid #dddddd;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.tab_item {
  width: 50%;
  height: 30px;
  line-height: 30px;
  display: inline-block;
  text-align: center;
  color: #212121;
  cursor: pointer;
}
.tab .el-tabs__item {
  padding: 0;
  width: 75px;
  height: 30px;
  text-align: center;
  box-sizing: border-box;
  line-height: 30px;
  display: inline-block;
  list-style: none;
  color: #212121;
  position: relative;
}

.active {
  border-bottom: 2px solid #34d1bc;
}

.special_cont {
  padding: 25px;
}

.special-img {
  float: left;
  width: 50%;
}

.special_cont img {
  width: 365px;
  height: 322px;
}

.cont_title {
  font-size: 18px;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
  padding-bottom: 15px;
}

.land_cont,
.greenest_cont {
  display: inline-block;
  width: 50%;
  margin: 60px auto 0;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 30px;
}

.fileDown {
  width: 120px;
  height: 35px;
  line-height: 31px;
  margin-top: 30px;
  background: #ffffff;
  border: 2px solid #34d1bc;
  border-radius: 18px;
  font-size: 14px;
  font-weight: 400;
  color: #34d1bc;
  text-align: center;
  cursor: pointer;
  box-sizing: border-box;
}

.info_title {
  width: 100%;
  border-bottom: 1px solid #dddddd;
  display: flex;
  justify-content: center;
}

.info_item {
  width: 50%;
  height: 35px;
  line-height: 35px;
  text-align: center;
  border-bottom: 2px solid #34d1bc;
}

.info_cont {
  padding: 25px 0;
  width: 100%;
  overflow: auto;
}

table {
  width: 700px;
  border: 1px solid #dddddd;
  border-collapse: collapse;
  color: #666666;
  font-weight: 500;
  font-size: 12px;
}

table tr {
  height: 35px;
}

table td {
  text-align: center;
}

.table-title {
  width: 1200px;
  height: 30px;
  background: #2581e8;
  font-family: PingFang-SC-Medium;
  color: #ffffff;
  line-height: 30px;
}

@media only screen and (max-width: 1280px) {
  .special_cont {
    padding: 25px 0;
  }

  .special_cont img {
    width: 80%;
  }

  .land_cont,
  .greenest_cont {
    width: 50%;
    margin: 10px auto 0;
  }

  .cont_title {
    font-size: 20px;
  }

  .fileDown {
    margin: 20px auto 0;
  }
}

@media only screen and (max-width: 600px) {
  .special_cont {
    padding: 25px 0;
  }

  .special-img {
    width: 100%;
  }

  .special_cont img {
    width: 100%;
  }

  .land_cont,
  .greenest_cont {
    width: 100%;
    margin: 10px auto 0;
  }

  .cont_title {
    font-size: 20px;
  }

  .fileDown {
    margin: 20px auto 0;
  }
}
</style>
<style>
.shortWarn {
  min-width: 180px;
}
</style>
